// extracted by mini-css-extract-plugin
module.exports = {"image":"product-doc-preview-module--image--2Nqke","alignWrapper":"product-doc-preview-module--align-wrapper--3-ffR","title":"product-doc-preview-module--title--UOQ_F"};